/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as appV1 from "./keyapis_multiapp_app_v1.pb"

/**
 * Сервис реализует функционал управления уведомлениями
 */

/**
 * Сервис уведомлений
 */
export class NotificationServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод отправки уведомления уведомления.
   * Метод доступен для: partner.
   * Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization
   */
  PostNotification = (req: PostNotificationRequestDto, init?: RequestInit): Promise<PostNotificationResponseDto> => {
    return fm.request<PostNotificationRequestDto, PostNotificationResponseDto>(`${this.host}/multiapp/api/v1/notification`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Уведомление
 */
export type NotificationRequestDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  appId: string
  /**
   * ОРПОН.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..150
   */
  roomNumbers: string[]
  /**
   * Идентификатор шаблона.
   * # Тип: Guid
   */
  templateId: string
  /**
   * Значения для подстановки в текст шаблона
   */
  values: {[key:string]:string}
  /**
   * Полезная нагрузка
   */
  payload?: {[key:string]:string}
}
/**
 * Уведомление
 */
export type NotificationResponseDto = {
  /**
   * Идентификатор приложения.
   * # Тип: Guid
   */
  appId: string
  /**
   * ОРПОН.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..150
   */
  roomNumbers: string[]
  /**
   * Идентификатор шаблона.
   * # Тип: Guid
   */
  templateId: string
  /**
   * Значения для подстановки в текст шаблона
   */
  values: {[key:string]:string}
  /**
   * Полезная нагрузка
   */
  payload: {[key:string]:string}
}
/**
 * Запрос сохранения уведомления
 */
export type PostNotificationRequestDto = {
  /**
   * Уведомление
   */
  data: NotificationRequestDto
}
/**
 * Ответ на запрос сохранения уведомления
 */
export type PostNotificationResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostNotificationResponseErrorDto
}>
/**
 * Ошибка запроса сохранения уведомления
 */
export type PostNotificationResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Значения для подстановки не соответствуют шаблону уведомления
   */
  readonly values: PostNotificationResponseErrorValuesErrorRequestDto
  /**
   * Приложение находится в статусе \"Заблокировано\"
   */
  readonly appBlocked: PostNotificationResponseErrorAppBlockedErrorRequestDto
  /**
   * Ошибка связанная с назначениями приложения
   */
  readonly appAssignment: PostNotificationResponseErrorAppAssignmentErrorRequestDto
}>
/**
 * Ошибка запроса сохранения уведомления
 */
export type PostNotificationResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Значения для подстановки не соответствуют шаблону уведомления
   */
  readonly values: PostNotificationResponseErrorValuesErrorDto
  /**
   * Приложение находится в статусе \"Заблокировано\"
   */
  readonly appBlocked: PostNotificationResponseErrorAppBlockedErrorDto
  /**
   * Ошибка связанная с назначениями приложения
   */
  readonly appAssignment: PostNotificationResponseErrorAppAssignmentErrorDto
}>
/**
 * Ошибка свзяанная с назначениями приложения.
 * Причины:
 * - Приложение назначено не только по ОРПОНу или ОРПОНу и номеру квартиры;
 * - Приложение не назначено на переданные orpon и room_number
 */
export type PostNotificationResponseErrorAppAssignmentErrorRequestDto = {
}
/**
 * Ошибка свзяанная с назначениями приложения.
 * Причины:
 * - Приложение назначено не только по ОРПОНу или ОРПОНу и номеру квартиры;
 * - Приложение не назначено на переданные orpon и room_number
 */
export type PostNotificationResponseErrorAppAssignmentErrorDto = {
}
/**
 * Приложение находится в статусе \"Заблокировано\"
 */
export type PostNotificationResponseErrorAppBlockedErrorRequestDto = {
}
/**
 * Приложение находится в статусе \"Заблокировано\"
 */
export type PostNotificationResponseErrorAppBlockedErrorDto = {
}
/**
 * Значения для подстановки не соответствуют шаблону уведомления
 */
export type PostNotificationResponseErrorValuesErrorRequestDto = {
}
/**
 * Значения для подстановки не соответствуют шаблону уведомления
 */
export type PostNotificationResponseErrorValuesErrorDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Уведомление
   */
  "Notification": {
    "kind": "class",
    "text": "Уведомление",
    "fields": {
      /**
       * Идентификатор приложения.
       * # Тип: Guid
       */
      "appId": {
        "type": "string",
        "text": "Идентификатор приложения.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН.
       * # Диапазон 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\n# Диапазон 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..150
       */
      "roomNumbers": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..150",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 150,
            "message": "Значение не входит в допустимый диапазон. Максимум: 150"
          },
        }
      },
      /**
       * Идентификатор шаблона.
       * # Тип: Guid
       */
      "templateId": {
        "type": "string",
        "text": "Идентификатор шаблона.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значения для подстановки в текст шаблона
       */
      "values": {
        "type": "{[key:string]:string}",
        "text": "Значения для подстановки в текст шаблона",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Полезная нагрузка
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Полезная нагрузка",
      },
    },
  },
  /**
   * Запрос сохранения уведомления
   */
  "PostNotificationRequest": {
    "kind": "class",
    "text": "Запрос сохранения уведомления",
    "fields": {
      /**
       * Уведомление
       */
      "data": {
        "type": "Notification",
        "text": "Уведомление",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения уведомления
   */
  "PostNotificationResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения уведомления",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostNotificationResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения уведомления
   */
  "PostNotificationResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Значения для подстановки не соответствуют шаблону уведомления
       */
      "values": {
        "type": "PostNotificationResponse.Error.ValuesError",
        "text": "Значения для подстановки не соответствуют шаблону уведомления",
      },
      /**
       * Приложение находится в статусе \"Заблокировано\"
       */
      "appBlocked": {
        "type": "PostNotificationResponse.Error.AppBlockedError",
        "text": "Приложение находится в статусе \"Заблокировано\"",
      },
      /**
       * Ошибка связанная с назначениями приложения
       */
      "appAssignment": {
        "type": "PostNotificationResponse.Error.AppAssignmentError",
        "text": "Ошибка связанная с назначениями приложения",
      },
    },
  },
  /**
   * Ошибка свзяанная с назначениями приложения.
   * Причины:
   * - Приложение назначено не только по ОРПОНу или ОРПОНу и номеру квартиры;
   * - Приложение не назначено на переданные orpon и room_number
   */
  "PostNotificationResponse.Error.AppAssignmentError": {
    "kind": "class",
    "text": "Ошибка свзяанная с назначениями приложения.\nПричины:\n- Приложение назначено не только по ОРПОНу или ОРПОНу и номеру квартиры;\n- Приложение не назначено на переданные orpon и room_number",
  },
  /**
   * Приложение находится в статусе \"Заблокировано\"
   */
  "PostNotificationResponse.Error.AppBlockedError": {
    "kind": "class",
    "text": "Приложение находится в статусе \"Заблокировано\"",
  },
  /**
   * Значения для подстановки не соответствуют шаблону уведомления
   */
  "PostNotificationResponse.Error.ValuesError": {
    "kind": "class",
    "text": "Значения для подстановки не соответствуют шаблону уведомления",
  },
}